import { Node } from '@tiptap/core'
import { store } from '@/store'
import router from '@/router'

export const AddTemplateButton = Node.create({
  name: 'addTemplate',

  defaultOptions: {
    HTMLAttributes: {}
  },

  group: 'block',
  selectable: false,

  parseHTML () {
    return [{ tag: 'button.add-template' }]
  },

  renderHTML () {
    return ['button', { class: 'add-template' }, 'Use template']
  },

  addCommands () {
    return {
      addTemplateButton: () => ({ state, dispatch, tr }) => {
        if (router.currentRoute.value.name !== 'Share') {
          const node = state.schema.nodes.addTemplate.create(null)

          dispatch(tr.insert(tr.doc.content.size, node))
        }
      },

      removeTemplateButton: () => ({ state, dispatch, tr }) => {
        state.doc.nodesBetween(1, tr.doc.content.size, (node, startPos) => {
          if (node.type.name === 'addTemplate') {
            dispatch(tr.delete(startPos, startPos + 1))
          }
        })
      }
    }
  },

  addNodeView () {
    const editor = this.editor

    return () => {
      const dom = document.createElement('button')

      const opacity = store.getters.isDarkMode ? 'opacity-50' : 'opacity-20'

      window.addEventListener('darkModeEvent', (e) => {
        if (e.detail.isDarkMode) {
          dom.classList.remove('opacity-20')
          dom.classList.add('opacity-50')
        } else {
          dom.classList.remove('opacity-50')
          dom.classList.add('opacity-20')
        }
      }, false)

      dom.classList.add('add-template', 'bg-dark-600', 'anim-opacity', 'hover:opacity-100', opacity)

      const openTemplateModal = () => {
        if (router.currentRoute.value.name !== 'Share') {
          editor.chain().blur().run()
          store.commit('changeTemplateState', 'All')
          store.commit('toggleTemplateModal', true)
          store.commit('toggleTemplateAside', false)
        }
      }

      dom.addEventListener('click', openTemplateModal)

      dom.disabled = router.currentRoute.value.name === 'Share'

      dom.innerHTML = 'Templates'

      return {
        dom,
        destroy () {
          dom.removeEventListener('click', openTemplateModal)
        }
      }
    }
  }
})
